import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, RequestOptionsArgs, Headers } from '@angular/http';
import { HttpService } from './../http/http.service';
import * as Models from './../models';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { Router } from '@angular/router';


@Injectable()
export class UserService {

    private _userDetails: Models.UserDetails;

    constructor(private http: HttpService,
        private authenticationService: AuthenticationService,
        private router: Router) {
    }

    getUserDetails(): Observable<Models.UserDetails> {
        return this.http.get('user/getProfile', { cache: false })
            .map((res: Response) => res.json());
    }

    saveUserDetails(context: Models.UserDetails): Observable<Models.UserDetails> {
        return this.http.post('user/saveProfile', JSON.stringify(context), { cache: false })
            .map((res: Response) => res.json());
    }


    get userDetails(): Models.UserDetails {
        return this._userDetails;
    }

    get hasUserDetais(): boolean {
        return this._userDetails != null;
    }

    setUserDetails(userDetails?: Models.UserDetails) {
        this._userDetails = userDetails;
    }

    get userFullName(): string {
        return this._userDetails ? this._userDetails.firstName + ' ' + this._userDetails.lastName : '';
    }

    get userEmail(): string {
        return this._userDetails ? this._userDetails.email : '';
    }

    updateUserDetails(): void {
        this.getUserDetails()
            .subscribe(userDetails => {
                this.setUserDetails(userDetails);
            }, error => {
                this.setUserDetails(null);
                this.authenticationService.logout();
                this.router.navigate(['/home'], { replaceUrl: true });
                window.location.reload();
            });
    }

}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/user/user.service.ts